import React, { Component } from 'react'
// import ScrollToTop from 'components/ScrollToTop.jsx'
import { url_rest, about_us, image_gallery, where_are_we } from 'configuration'
import { getRequest, postRequest } from 'services/ApiService.js'
// import Layout from 'components/Layout.jsx';
import MapeaComponent from './MapeaComponent'

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

export default class ResourceFileContent extends Component {

	constructor(props) {
		super(props);

		this.state = {
	      photoIndex: 0,
	      isOpen: false,
	      result: null
	    };

		var data = {
			"item_number": 0,
			"page_size": 20,
			"filters": {
				"slug": this.props.queryTerm
			}
		};

		postRequest(url_rest + "/resource/paginated", data, this.props.lang).then(
			(response) => {
				getRequest(url_rest + "/resource/get/" + response.data.list[0].id, this.props.lang).then(
					(response) => {
						this.setState({ result: response.data })
					});
			});
	}

	printGallery() {
		const images = this.state.result.multimedia_list;
		var reactModalStyle = {
			overlay: {
				zIndex: 3000
			} 
		};

		const { photoIndex, isOpen } = this.state;
		var gallery = [];
		if (this.state.result.multimedia_list) {
			gallery.push(<h3>{image_gallery[this.props.lang]}</h3>);
			for (let i = 0; (i < 4) && (i < this.state.result.multimedia_list.length); i++) {
				gallery.push(
					<div className="slider">
						<div className="slider-inner">
							<div className="slide" onClick={() => this.setState({ isOpen: true, photoIndex: i})}>
								<img src={this.state.result.multimedia_list[i].file} alt={this.state.result.name} style={{ position: 'inherit', left: '0', top: 'inherit', width: '750px', height: 'inherit' }} />
							</div>
						</div>
					</div>
				);
			}
		}

		{isOpen && (
			gallery.push(<Lightbox
				mainSrc={images[photoIndex].file}
				nextSrc={images[(photoIndex + 1) % images.length]}
				prevSrc={images[(photoIndex + images.length - 1) % images.length]}
				onCloseRequest={() => this.setState({ isOpen: false })}
				onMovePrevRequest={() =>
				  this.setState({
				    photoIndex: (photoIndex + images.length - 1) % images.length,
				  })
				}
				onMoveNextRequest={() =>
				  this.setState({
				    photoIndex: (photoIndex + 1) % images.length,
				  })
				}
				enableZoom={false}
				reactModalStyle={reactModalStyle}
			/>)
        )}

		return gallery;
	}

	

	render() {
		

		if (this.state.result != null) {
			var web = '';
			var phone = '';
			var address = '';
			var map = '';
			if (this.state.result.contact_information) {
				if (this.state.result.contact_information[0].web) {
					web = <div className="info-div"><i className="fas fa-link c-orange"></i><label>{this.state.result.contact_information[0].web}</label></div>
				}
				if (this.state.result.contact_information[0].first_phone_number) {
					phone = <div className="info-div"><i className="fas fa-phone c-blue"></i><label>{this.state.result.contact_information[0].first_phone_number}</label></div>
				}
			}

			if (this.state.result.address_number && this.state.result.vial_name) {
				address = <p><i className="fas fa-map-marker-alt fa-1x"></i>{this.state.result.address_number + ', ' + this.state.result.vial_name}</p>
			}

			if (this.state.result.x_coord && this.state.result.y_coord) {
				map = <MapeaComponent x_coord={this.state.result.x_coord } y_coord={this.state.result.y_coord}/>
				{
				/*<iframe src={"http://maps.andalucia.org/maps/search?" + btoa('resource=' + this.state.result.id)} width="100%" height="100%" style={{ border: '0' }}></iframe>*/
				}
			}

			return (
				<div className="content-lvl-3">
					<div className="fullscreen-background" style={{ backgroundImage: 'url(' + this.state.result.image + ')' }} >

						<div className="content-lvl-2 cards-lvl-2-content page-title title-resource">

						</div>

						<div className="resource-wrapper">
							<h1>{this.state.result.name}</h1>

							<div className="resource-content">
								<div>

									<div className="description-wrapper">
										<h2>{about_us[this.props.lang]}</h2>
										<p>{this.state.result.description}</p>
									</div>
									<div className="slider-wrapper">
										{this.printGallery()}
									</div>
									<div className="maps-wrapper">
										<h3>{where_are_we[this.props.lang]}</h3>
										{map}
										{address}
										{/* <div className="info-div"><i className="fas fa-map-marker-alt c-green"></i><label>{this.state.result.vial_name + ', ' + this.state.result.address_number}</label></div> */}
										{phone}
										{web}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		else { return "" }
	}
}



// WEBPACK FOOTER //
// ./src/components/ResourceFileContent.jsx